<template>
  <router-view/>
</template>
<script>
import {CURRENT_STORE_QUERY} from '@/services/graphql/store';

export default {
  data() {
    return {
      storeNow: null,
    }
  },
  metaInfo() {
    return {
      title: this.storeNow ? this.storeNow.name : '賣店',
    };
  },
  methods: {
    async getStoreInfo() {
      try {
        const q = await this.$apollo.query({
          query: CURRENT_STORE_QUERY,
          fetchPolicy: "network-only"
        });
        this.storeNow = q.data.storeNow;
      } catch (err) {
        console.error(err);
      }
    },
    fbInit() {
      if(!this.storeNow.facebook_fanpage_id) {
        return;
      }
      var chatbox = document.getElementById('fb-customer-chat');
      chatbox.setAttribute("page_id", this.storeNow.facebook_fanpage_id);
      chatbox.setAttribute("attribution", "biz_inbox");

      window.fbAsyncInit = function() {
        FB.init({
          xfbml            : true,
          version          : 'v12.0'
        });
      };

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
  },
  async mounted() {
    await this.getStoreInfo();
    this.fbInit();
  }
};
</script>

